import React, { useState } from "react";
import { Row, Col, message, Popover } from "antd";
import "react-step-progress-bar/styles.css";
import ProgressBar from "../../components/ProgressBar";
import Wrapper from "../../components/Wrapper";
import { useRecoilState } from "recoil";
import { userAtom } from "../../Recoil/Atoms/user";

import { ReactComponent as Nuts } from "../../assets/nut.svg";
import { ReactComponent as Milk } from "../../assets/milk.svg";
import { ReactComponent as Cheese } from "../../assets/cheese.svg";
import { ReactComponent as Nutselected } from "../../assets/nutSelected.svg";
import { ReactComponent as MilkSelected } from "../../assets/milkSelected.svg";
import { ReactComponent as CheeseSelected } from "../../assets/cheeseSelected.svg";
import { ReactComponent as Tofu } from "../../assets/tofu.svg";
import { ReactComponent as TofuSelected } from "../../assets/tofu-1.svg";
import { ReactComponent as Right } from "../../assets/Icon awesome-check.svg";
import { ReactComponent as Wrong } from "../../assets/Icon metro-cross.svg";
import { ReactComponent as Curd } from "../../assets/curd.svg";
import { ReactComponent as CurdSelected } from "../../assets/curd-1.svg";

let LIST_VEG = [
  // {
  //   id: 1,
  //   Title: "Nuts",
  //   icon: Nuts,
  //   selectedIcon: Nutselected,
  // },

  {
    id: 2,
    Title: "Curd",
    icon: Curd,
    selectedIcon: CurdSelected,
    content: "AVOID CASIEN/ LACTOSE INTOLERENT",
  },
  {
    id: 3,
    Title: "SoyaMilk",
    icon: Milk,
    selectedIcon: MilkSelected,
    content: "AVOID SOY SENSITIVITY",
  },
  {
    id: 4,
    Title: "Cheese",
    icon: Cheese,
    selectedIcon: CheeseSelected,
    content: "AVOID LACTOSE INTOLERENT",
  },
  {
    id: 5,
    Title: "Tofu",
    icon: Tofu,
    selectedIcon: TofuSelected,
    content: "AVOID SOY SENSITIVITY",
  },

  {
    id: 7,
    Title: "ButterMilk",
    icon: Milk,
    selectedIcon: MilkSelected,
    content: "AVOID LACTOSE INTOLERENT",
  },
  {
    id: 8,
    Title: "Paneer",
    icon: Cheese,
    selectedIcon: CheeseSelected,
    content: "AVOID CASIEN INTOLERENT / IF FEEL BLOTING",
  },

  {
    id: 10,
    Title: "Skimmed milk",
    icon: Milk,
    selectedIcon: MilkSelected,
    content: "AVOID LACTOSE INTOLERANT / ANAPHYLAXIS",
  },
];

const SelectGender = (props) => {
  const [selected, setSelected] = useState([]);
  const [userData, setUserData] = useRecoilState(userAtom);
  const [update, setupdater] = useState(false);

  const selectedMethod = (item) => {
    if (selected.indexOf(item.Title) !== -1) {
      let tempSelected = selected;
      tempSelected.splice(tempSelected.indexOf(item.Title), 1);
      // console.log("TempSelected", tempSelected);
      setSelected(tempSelected);
    } else {
      setSelected([...selected, item.Title]);
    }
    setupdater(!update);
  };
  const selectNonVeg = async () => {
    if (selected.length > 2) {
      await setUserData({ ...userData, dairy: selected });
      props.history.push("/SFS");
      // console.log(userData);
    } else {
      message.error("Please select at least 3 option");
    }
  };
  return (
    <Wrapper {...props}>
      <Row className={"select_row"} align={"top"} justify="start">
        <Col align="left" span={8} xs={24} md={8}>
          <div className="blockname">
            <div style={{ marginLeft: "10rem" }} className="blocknametext">
              SELECT
            </div>
            <div style={{ marginLeft: "8rem" }} className="blocknametext">
              Dairy
            </div>
            <div style={{ marginLeft: "5.8rem" }} className="blocknametext">
              Products
            </div>
          </div>
        </Col>
        <Col align="center" span={8} xs={24} md={16}>
          <Row
            style={{ marginTop: "3rem" }}
            gutter={10}
            align="middle"
            justify="center"
          >
            <Col>
              <Right className="icon-change" />
            </Col>
            <Col className="background--grey">
              <h4 className="heading">Include / Exclude</h4>
            </Col>
            <Col>
              <Wrong className="icon-change" />
            </Col>
          </Row>
          <Row align="middle" justify="center">
            <h5 className="sub_heading background--grey">
              PLEASE CLICK TO INCLUDE PRODUCTS YOU LIKE:
            </h5>
          </Row>

          <Row gutter={[16, 24]} align="middle" justify="center">
            {LIST_VEG.map((item, key) => {
              return (
                <Popover
                  content={item.content}
                  title={item.Title}
                  trigger="hover"
                >
                  <Col
                    onClick={() => selectedMethod(item)}
                    key={key}
                    align="center"
                    className={
                      selected.includes(item.Title)
                        ? "block__selected"
                        : "block"
                    }
                    span={6}
                  >
                    <Row
                      flex={1}
                      style={{ width: "100%" }}
                      align="middle"
                      justify="end"
                    >
                      {selected.includes(item.Title) ? (
                        <Right height="1rem" />
                      ) : (
                        <Wrong height="1rem" />
                      )}
                    </Row>
                    {selected.includes(item.Title) ? (
                      <item.selectedIcon height="5rem" />
                    ) : (
                      <item.icon height="5rem" />
                    )}
                    <h4 className="block_header">{item.Title}</h4>
                  </Col>
                </Popover>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Row align="middle" justify="center">
        <div onClick={() => selectNonVeg()} className="rowlabel">
          Continue
        </div>
      </Row>
      <ProgressBar value={80} />
    </Wrapper>
  );
};

export default SelectGender;
